import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useLoader } from "../../../context/LoaderProvider.jsx";

const Waiterpage = () => {
    const [formData, setFormData] = useState({
        type: '',
        description: '',
        goal: '',
        startDate: '',
        endDate: '',
        discount: '',
    });

    const [couponRequests, setCouponRequests] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const { showLoader, hideLoader } = useLoader();
    const isMobile = window.innerWidth <= 768;
    const [floorsData, setFloorsData] = useState([]);
    const navigate = useNavigate();
    useEffect(() => {
        const vendorId = localStorage.getItem("vendorId");   // 🔹 read vendorId
        const authToken = localStorage.getItem("authToken"); // 🔹 read token

        if (!vendorId || !authToken) {
            console.error("❌ vendorId or authToken missing in localStorage");
            return;
        }
        showLoader();
        axios
            .get(
                `https://backend.maamaas.com/food/api/seatingdetails/vendor/${vendorId}/vendor-bookings`,
                {
                    headers: {
                        Authorization: `Bearer ${authToken}`, // 🔹 attach token
                    },
                }
            )
            .then((res) => {
                setFloorsData(res.data);
            })
            .catch((err) => {
                console.error("Error fetching floors:", err);
            }).finally(() => {
                hideLoader();
            })
    }, []);



    return (
        <div
            style={{
                // padding: '20px',
                maxWidth: isMobile ? 'auto' : '1200px',
                margin: isMobile ? 'auto' : '0px auto',
                boxSizing: 'border-box',
                position: 'relative',
                width: '100%',
            }}
        >


            {/* Table Section */}
            <div style={{
                // marginTop: '10px',
                overflowX: 'auto',
                width: '100%'
            }}>
                <div style={{
                    minWidth: '800px',
                    width: '100%'
                }}>
                    <table
                        style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            backgroundColor: "white",
                            border: "1px solid #ccc",
                        }}
                    >
                        <thead>
                            <tr>
                                {[
                                    "S.No",
                                    "Guest Name",
                                    "Bookig Date",
                                    "Time",
                                    "Table Number",
                                    "Capacity",
                                    "Arrival Status",
                                    "PhoneNumber",
                                    "Seating Id",
                                    "Add Iteams"
                                ].map((head, i) => (
                                    <th
                                        key={i}
                                        style={{
                                            border: "1px solid #ccc",
                                            padding: "10px",
                                            backgroundColor: "#b15cd6",
                                            fontSize: "clamp(10px, 2vw, 14px)",
                                            textAlign: "left",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {head}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {floorsData.map((floor, index) => (
                                <tr key={floor.id}>
                                    <td style={cellStyle}>{index + 1}</td>
                                    <td style={cellStyle}>{floor.guestName}</td>
                                    <td style={cellStyle}>
                                        {floor.bookingDate
                                            ? new Date(floor.bookingDate).toLocaleDateString("en-GB")
                                            : "-"}
                                    </td>
                                    <td style={cellStyle}>{floor.startTime}</td>
                                    <td style={cellStyle}>{floor.code}</td>
                                    <td style={cellStyle}>{floor.capacity}</td>
                                    <td style={cellStyle}>{floor.arrivalStatus ?? "-"}</td>
                                    <td style={cellStyle}>{floor.phoneNumber ?? "-"}</td>
                                    <td style={cellStyle}>{floor.seatingId ?? "-"}</td>
                                    <td style={cellStyle}>
                                        <button
                                            style={{
                                                padding: "6px 12px",
                                                backgroundColor: "#b15cd6",
                                                color: "white",
                                                fontSize: "14px",
                                                border: "none",
                                                borderRadius: "5px",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              
                                                // ✅ Store both seatingId and tableCode
                                                localStorage.setItem("seatingId", floor.seatingId);
                                                localStorage.setItem("tableCode", floor.code);

                                                navigate("/waitermenu", {
                                                    state: {
                                                        floorId: floor.id,
                                                        seatingId: floor.seatingId,
                                                        tableCode: floor.code,
                                                    },
                                                });
                                            }}
                                        >
                                            Add Items
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>

                    </table>
                </div>
            </div>

            {/* Modal Popup */}

        </div>
    );
};


const cellStyle = {
    border: "1px solid #ccc",
    padding: "10px",
    fontSize: "clamp(10px, 2vw, 14px)",
};
const labelStyle = {
    fontSize: 'clamp(12px, 2vw, 14px)',
    marginBottom: '4px',
    display: 'block',
};

const tdStyle = {
    padding: '10px',
    border: '1px solid #ccc',
    textAlign: 'left',
};

export default Waiterpage;